import { defineMessages } from 'react-intl';

export const locationSelectorMessages = defineMessages({
  'locationSelector:fetchingYourLocationLabel': {
    id: 'locationSelector:fetchingYourLocationLabel',
    defaultMessage: 'Fetching your location...',
    description: "Message displayed when the app is fetching the user's current location.",
  },
  'locationSelector:nearbyLabel': {
    id: 'locationSelector:nearbyLabel',
    defaultMessage: 'Nearby',
    description: 'Label for the nearby location option in the location selector.',
  },
  'locationSelector:allLabel': {
    id: 'locationSelector:allLabel',
    defaultMessage: 'All',
    description: 'Label for the all locations option in the location selector.',
  },
});
